export const createUserlist = (data = {}) => {
  const all_user = data.all_user || [];
  return {
    ...data,
    all_user
  }
}
export const createExternalUserlist = (data = {}) => {
  const ext_users = data.ext_users || [];
  return {
    ...data,
    ext_users
  }
}